import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import CityProvinceCountrySelector from "../../designSystem/CityProvinceCountrySelector";
import TextField from "../../designSystem/TextField";
import TimePicker from "../../designSystem/TimePicker";

const BusinessInformation = ({ divisions, readOnly }) => {
    const { register, formState: { errors } } = useFormContext();

    return (
        <Row className="my-4">
            <Col sm={12}>
                <fieldset className="mb-3">
                    <label className="label-heading">Business Information</label>
                    <Row className="gy-2 mb-2">
                        <Col sm={2}>
                            <Form.Group controlId="invoicecareaa">
                                <FloatingLabel
                                    controlId="floatingInput"
                                    label="Select Division"
                                >
                                    <Form.Select {...register("division", { required: "Field is Required" })} >
                                        <option value="">Select</option>
                                        {divisions?.map((division) => (
                                            <option key={division.divisionId} value={division.divisionName}>
                                                {division.divisionName}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FloatingLabel>
                                {errors?.streetName?.message ? <span className="text-danger">{errors?.division?.message}</span> : null}
                            </Form.Group>
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Company Name" {...register("companyName", { required: "Field is Required" })} error={errors?.companyName?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Street" {...register("streetNo", { required: "Field is Required" })} error={errors?.streetNo?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Street Name" {...register("streetName", { required: "Field is Required" })} error={errors?.streetName?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Unit" {...register("unit")} error={errors?.unit?.message} />
                        </Col>
                        <CityProvinceCountrySelector readOnly={readOnly} formNamespace="companyProfile" />
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Postal Code" {...register("postalCode", { required: "Field is Required" })} error={errors?.postalCode?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Email" {...register("email", { required: "Field is Required" })} error={errors?.email?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Phone Number" {...register("phoneNumber", { required: "Field is Required" })} error={errors?.phoneNumber?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Fax Number" {...register("faxNumber", { required: "Field is Required" })} error={errors?.faxNumber?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Business Number" {...register("businessNumber", { required: "Field is Required" })} error={errors?.businessNumber?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Tax Number" {...register("taxNumber", { required: "Field is Required" })} error={errors?.taxNumber?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Website" {...register("website", { required: "Field is Required" })} error={errors?.website?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Division Prefix" helperText="This will be used as a prefix for creating trips in the dispatch module under this division." {...register("divisionPrefix", {
                                required: "Field is Required", pattern: {
                                    value: /^.{2}$/,
                                    message: "Division prefix must be 2 characters",
                                },
                            })} error={errors?.divisionPrefix?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Icon" {...register("icon", { required: "Field is Required" })} error={errors?.icon?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Contact" {...register("contact", { required: "Field is Required" })} error={errors?.contact?.message} />
                        </Col>
                        <Col sm={2}>
                            <TextField readOnly={readOnly} label="Phone Ext" {...register("phoneExt", { required: "Field is Required" })} error={errors?.phoneExt?.message} />
                        </Col>
                        <Col sm={2}>
                            <TimePicker readOnly={readOnly} label="Open Time" {...register("openTime", { required: "Field is Required" })} error={errors?.openTime?.message} />
                        </Col>
                        <Col sm={2}>
                            <TimePicker readOnly={readOnly} label="Close Time" {...register("closeTime", { required: "Field is Required" })} error={errors?.closeTime?.message} />
                        </Col>
                        <Row className="pe-0">
                            <Col sm={12} className="pe-0">
                                <TextField style={{ minHeight: "100px" }} as="textarea" readOnly={readOnly} label="Location Notes" {...register("locationNotes", { required: "Field is Required" })} error={errors?.locationNotes?.message} />
                            </Col>
                        </Row>
                    </Row>
                </fieldset>
            </Col>
        </Row>
    )
}

export default BusinessInformation